import { render, staticRenderFns } from "./ApplicationFormIndividualDocuments.vue?vue&type=template&id=728a9e9e&scoped=true"
import script from "./ApplicationFormIndividualDocuments.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormIndividualDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormIndividualDocuments.vue?vue&type=style&index=0&id=728a9e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a9e9e",
  null
  
)

export default component.exports